import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sales: [],
  tempSales: [],
  isLoading: false,
  tempReturn: [],
  returns: [],
  deliveryData: [],
  isDeliveryLoading: false,
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
  returnPagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
};

const saleSlice = createSlice({
  name: "sales",
  initialState,
  reducers: {
    setSales(state, action) {
      state.sales = action.payload;
      state.isLoading = false;
    },
    setTempSales(state, action) {
      state.tempSales = action.payload;
    },
    setTempReturn(state, action) {
      state.tempReturn = action.payload;
    },
    setReturns(state, action) {
      state.returns = action.payload;
    },
    setSalePagination(state, action) {
      state.pagination = action.payload;
    },
    setSaleReturnPagination(state, action) {
      state.returnPagination = action.payload;
    },
    addSale(state, action) {
      state.sales.push(action.payload);
      state.tempSales.push(action.payload);
    },
    updateSale(state, action) {
      const { index, sale } = action.payload;
      state.sales?.splice(index, 1, sale);
      state.tempSales?.splice(index, 1, sale);
    },
    deleteSale(state, action) {
      const { index } = action.payload;
      state.sales.splice(index, 1);
      state.tempSales.splice(index, 1);
    },
    setSaleIsLoading(state, action) {
      state.isLoading = true;
    },
    setDeliveryData(state, action) {
      state.deliveryData = action.payload;
      state.isDeliveryLoading = false;
    },
    setDeliveryIsLoading(state, action) {
      state.isDeliveryLoading = true;
    },
  },
});

export const {
  setSales,
  setTempSales,
  addSale,
  updateSale,
  deleteSale,
  setSaleIsLoading,
  setSalePagination,
  setSaleReturnPagination,
  setTempReturn,
  setReturns,
  setDeliveryData,
  setDeliveryIsLoading,
} = saleSlice.actions;
export default saleSlice.reducer;
